/* eslint-disable func-names, max-len, no-underscore-dangle */
import 'fancybox-core';
import 'fancybox-media';

if ($('.jss').length < 1) {
  if ($('a[href*="youtube.com/watch?"]').length > 0 || $('a[href*="youtube.com/v/"]').length > 0 || $('a[href*="vimeo"]').length > 0 || $('.fancybox-media').length > 0) {
    // fancybox
    $('a[href*="youtube.com/watch?"]').addClass('fancybox-media');
    $('a[href*="youtube.com/v/"]').addClass('fancybox-media');
    $('a[href*="vimeo"]').addClass('fancybox-media');
    $('.fancybox-media').fancybox({ openEffect: 'none', closeEffect: 'none' });
  }
}

$('a.fancy-image').fancybox({ speedIn: 600, speedOut: 200 });

if ($('.js-fancy-link').length > 0) {
  $('.js-fancy-link').fancybox({
    maxWidth: 1000,
    maxHeight: 700,
    fitToView: false,
    width: '80%',
    height: '80%',
    autoSize: false,
    closeClick: false,
    openEffect: 'none',
    closeEffect: 'none',
  });
}

if ($('.js-youtube-fancybox').length) {
  $('.js-youtube-fancybox').fancybox({
    maxWidth: 1280,
    maxHeight: 720,
    fitToView: false,
    width: '80%',
    height: '80%',
    autoSize: false,
    closeClick: false,
    openEffect: 'none',
    closeEffect: 'none',
  });
}
